import {Fragment} from 'react';

const formatByName = (str, values) => {
    if (!str) return str;

    return str.replace(/\{\{|\}\}|\{(\w+)\}/g, (m, n) => {
        if (m === '{{') {
            return '{';
        }
        if (m === '}}') {
            return '}';
        }
        return values[n];
    });
};

export const formatString = (string, ...values) => {
    if (!string) return '';

    for (let i = 0; i < values.length; i++) {
        string = string.replace(`{${i}}`, values[i]);
    }

    return string;
};

export const formatStringWithComponentsOffset = (startIndex, template, ...components) => {
    const parts = template.split(/(\{\d+\})/g);

    return parts.map((part, i) => {
        const match = part.match(/\{(\d+)\}/);

        if (match) {
            return <Fragment key={i}>{components[+match[1] - startIndex]}</Fragment>;
        }
        return <Fragment key={i}>{part}</Fragment>;
    });
};

export const formatStringWithComponents = (template, ...components) =>
    formatStringWithComponentsOffset(0, template, ...components);

export const formatHtmlWithComponentsOffset = (startIndex, template, ...components) => {
    const parts = template.split(/(\{\d+\})/g);

    return parts.map((part, i) => {
        const match = part.match(/\{(\d+)\}/);

        if (match) {
            return <Fragment key={i}>{components[+match[1] - startIndex]}</Fragment>;
        }
        return <span key={i} dangerouslySetInnerHTML={{__html: part}} />;
    });
};

export const formatHtmlWithComponents = (template, ...components) =>
    formatHtmlWithComponentsOffset(0, template, ...components);

const capitalize = (str) => {
    if (!str) return;

    return str.charAt(0).toUpperCase() + str.slice(1);
};

export default {
    formatString,
    formatByName,
    capitalize,
    formatStringWithComponentsOffset,
    formatHtmlWithComponents,
    formatHtmlWithComponentsOffset,
};
